import React, { useState } from "react";
import {
  FormTItle,
  FormTItleValue,
  OrderTitle,
  StyledGridBox,
  StyledGridBoxChild,
} from "./OrderDetails";
import { Box, Button, CircularProgress } from "@mui/material";
import Grid from "@mui/material/Grid2";
import PreviewModal from "../../components/itin/PreviewModal";
import {
  DocumentUploadIcon,
  PreviewIcon,
} from "../../assets/Icon/dashboredIcon";
import moment from "moment";
import ListLoadingNew from "../../components/common-components/ListLoadingNew";
import NoOrdersFound from "../../components/common-components/NoOrdersFound";
import useDownloader from "react-use-downloader";
import { getUrl } from "../../stores/incorporation";
import { useAppDispatch } from "../../stores/store";
import { useSelector } from "react-redux";

interface listDataFormType {
  title?: string;
  value?: any;
  border?: boolean;
  icon?: any;
  key?: string;
  attribute?: string;
  country_code?: any;
}

interface OrderDetailCardProps {
  orderFormData: listDataFormType[];
  isViewButton?: boolean;
  isClassName?: boolean;
  cardTitle: string;
  margin?: boolean;
  loading?: boolean;
  countryCode?: any;
  hasUsCompany?: any;
  hasItinDocument?: any;
  hasEINDocument?: any;
  data?: any;
}

const OrderDetailCard = (props: OrderDetailCardProps) => {
  const {
    orderFormData,
    hasUsCompany,
    isViewButton,
    isClassName,
    cardTitle,
    margin,
    loading,
    countryCode,
    hasItinDocument,
    hasEINDocument,
    data,
  } = props;
  const [openPreview, setOpenPreview] = useState(false);
  const [img, setImg] = useState("");
  const [downloadingFile, setDownloadingFile] = useState<string | null>(null);
  const [showAll, setShowAll] = useState(false);
  const baseUrl = process.env.REACT_APP_BASE_IMAGE_URL || "";
  const { download } = useDownloader();
  const dispatch = useAppDispatch();

  const selectedOrder = useSelector((state: any) => state.orders.selectedOrder);
  // const taxOrderData = useSelector((state: any) => state.orders.taxOrderData);
  // console.log(taxOrderData,"=======taxOrderData");
  // console.log(orderFormData,"=======orderFormData");
  // const downloadFn = (fileUrl: string, fileName: string = "document.pdf") => {
  //   const downloadFile = async () => {
  //     try {
  //       const response = await fetch(fileUrl);
  //       if (!response.ok) {
  //         alert("Download failed");
  //         return;
  //       }
  //       const blob = await response.blob();
  //       const downloadUrl = window.URL.createObjectURL(blob);
  //       const a = document.createElement("a");
  //       a.href = downloadUrl;
  //       a.download = fileName;
  //       document.body.appendChild(a);
  //       a.click();
  //       a.remove();
  //       window.URL.revokeObjectURL(downloadUrl);
  //     } catch (error) {
  //
  //       alert("Something went wrong while downloading.");
  //     }
  //   };

  //   downloadFile(); // Trigger download
  // };

  const formatToTimeZone = (
    dateInput: string | Date,
    timeZone: string = Intl.DateTimeFormat().resolvedOptions().timeZone,
    locale: string = "en-US",
    options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "short",
      day: "2-digit",
    },
  ): string => {
    if (!dateInput) return "Invalid Date";

    const date = new Date(
      typeof dateInput === "string" && !dateInput.endsWith("Z")
        ? dateInput + "Z"
        : dateInput,
    );

    if (isNaN(date.getTime())) {
      return "Invalid Date";
    }

    return new Intl.DateTimeFormat(locale, {
      timeZone,
      ...options,
    }).format(date);
  };

  const handleDownload = async (
    fileUrl: string,
    fileName: string = "document.pdf",
  ) => {
    try {
      setDownloadingFile(fileUrl);
      // download(fileUrl, fileName);
      const response = await fetch(fileUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/octet-stream",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch file");
      }

      const reader = response.body?.getReader();
      if (!reader) {
        throw new Error("Failed to get stream reader");
      }

      const stream = new ReadableStream({
        async start(controller) {
          while (true) {
            const result = await reader.read();
            if (result.done) break;
            controller.enqueue(result.value);
          }
          controller.close();
          reader.releaseLock();
        },
      });

      const blob = await new Response(stream).blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      window.open(fileUrl, "_blank");
    } finally {
      setDownloadingFile(null);
    }
  };

  const handleClose = () => {
    setOpenPreview(false);
  };

  const industryItem = orderFormData.find(
    (item) => item.attribute === "industry_type_name",
  );
  const industryValue = industryItem?.value;

  const filteredOrderFormData = orderFormData.filter((item) => {
    if (item.attribute === "business_description") {
      return industryValue === "Other";
    }
    return true;
  });

  const handleDownloadUrl = async (url: string, attribute: string) => {
    try {
      setDownloadingFile(attribute);
      const response = await dispatch<any>(getUrl({ url: url }));
      const fileUrl = response?.payload?.data;

      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = fileUrl;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      setDownloadingFile(null);
    } finally {
      setDownloadingFile(null);
    }
  };

  console.log(filteredOrderFormData, "=======orderFormData");
  return (
    <>
      {!isClassName && (
        <OrderTitle
          sx={{
            fontWeight: "600 !important",
          }}
          isClassName={true}
        >
          {cardTitle}
        </OrderTitle>
      )}
      <StyledGridBoxChild
        size={{ xs: 12, md: 12 }}
        sx={{ marginTop: margin ? "20px" : "0" }}
      >
        {isClassName && (
          <OrderTitle
            sx={{
              fontWeight: "600 !important",
              paddingTop: "0px",
            }}
          >
            {cardTitle}
          </OrderTitle>
        )}

        {/* {hasUsCompany != undefined && ( */}
        <Box
          sx={{
            borderBottom: "1px solid #EAF1FACC",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            paddingY: "20px",
          }}
        >
          <FormTItle>Application Options</FormTItle>
          <FormTItleValue sx={{ fontWeight: "500 !important" }}>
            {hasUsCompany === true && "I have a US Company and EIN."}
            {hasUsCompany === false &&
              "I don’t have a US company and EIN, I will not start one for now."}
          </FormTItleValue>
        </Box>
        {/* )} */}

        {(showAll
          ? filteredOrderFormData
          : filteredOrderFormData.slice(0, 4)
        ).map((item, index) => {
          return (
            <Box
              key={index}
              sx={{
                borderBottom: item.border ? "1px solid #EAF1FACC" : "none",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                paddingY: "20px",
              }}
            >
              <FormTItle>{item.value ? item.title : ""}</FormTItle>

              <FormTItleValue
                sx={{ fontWeight: "500 !important", wordBreak: "break-all" }}
              >
                <span style={{ paddingRight: "10px" }}>{item?.icon}</span>
                {item?.title === "Created" ? (
                  <span>{formatToTimeZone(item?.value)}</span>
                ) : item.attribute === "phone_number" ? (
                  <span>{`${
                    orderFormData.find((i) => i.attribute === "country_code")
                      ?.value ||
                    countryCode ||
                    ""
                  }  ${item.value}`}</span>
                ) : item.attribute === "verified_form_files" ||
                  item.attribute === "ss4_verified_form_files" ? (
                  <span>{`${item.value[0]}`}</span>
                ) : item.attribute === "company_documents" &&
                  selectedOrder?.productId === 3 ? (
                  // Company Documents for tax filing (productId === 3) - handle both single and multiple
                  (() => {
                    const documents = Array.isArray(item.value)
                      ? item.value
                      : [item.value];
                    return (
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "8px",
                        }}
                      >
                        {documents.map((doc: string, docIndex: number) => (
                          <Box
                            key={docIndex}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setOpenPreview(true);
                                setImg(`${baseUrl}${doc}`);
                              }}
                            >
                              <PreviewIcon />
                            </span>
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                handleDownloadUrl(
                                  doc,
                                  `company_doc_${docIndex}`,
                                );
                              }}
                            >
                              {downloadingFile === `company_doc_${docIndex}` ? (
                                <CircularProgress
                                  sx={{
                                    width: "31px !important",
                                    height: "30px !important",
                                  }}
                                />
                              ) : (
                                <DocumentUploadIcon />
                              )}
                            </span>
                          </Box>
                        ))}
                      </Box>
                    );
                  })()
                ) : item.attribute === "itin_document" &&
                  selectedOrder?.productId === 3 ? (
                  // ITIN Documents for tax filing (productId === 3) - handle both single and multiple
                  (() => {
                    const documents = Array.isArray(item.value)
                      ? item.value
                      : [item.value];
                    return (
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "8px",
                        }}
                      >
                        {documents.map((doc: string, docIndex: number) => (
                          <Box
                            key={docIndex}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setOpenPreview(true);
                                setImg(`${baseUrl}${doc}`);
                              }}
                            >
                              <PreviewIcon />
                            </span>
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                handleDownloadUrl(doc, `itin_doc_${docIndex}`);
                              }}
                            >
                              {downloadingFile === `itin_doc_${docIndex}` ? (
                                <CircularProgress
                                  sx={{
                                    width: "31px !important",
                                    height: "30px !important",
                                  }}
                                />
                              ) : (
                                <DocumentUploadIcon />
                              )}
                            </span>
                          </Box>
                        ))}
                      </Box>
                    );
                  })()
                ) : item.attribute === "ein_document" &&
                  selectedOrder?.productId === 3 ? (
                  // EIN Documents for tax filing (productId === 3) - handle both single and multiple
                  (() => {
                    const documents = Array.isArray(item.value)
                      ? item.value
                      : [item.value];
                    return (
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "8px",
                        }}
                      >
                        {documents.map((doc: string, docIndex: number) => (
                          <Box
                            key={docIndex}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setOpenPreview(true);
                                setImg(`${baseUrl}${doc}`);
                              }}
                            >
                              <PreviewIcon />
                            </span>
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                handleDownloadUrl(doc, `ein_doc_${docIndex}`);
                              }}
                            >
                              {downloadingFile === `ein_doc_${docIndex}` ? (
                                <CircularProgress
                                  sx={{
                                    width: "31px !important",
                                    height: "30px !important",
                                  }}
                                />
                              ) : (
                                <DocumentUploadIcon />
                              )}
                            </span>
                          </Box>
                        ))}
                      </Box>
                    );
                  })()
                ) : item.attribute === "passport_scan" &&
                  selectedOrder?.productId === 3 ? (
                  // Passport Scan for tax filing (productId === 3) - handle both single and multiple
                  (() => {
                    const documents = Array.isArray(item.value)
                      ? item.value
                      : [item.value];
                    return (
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "8px",
                        }}
                      >
                        {documents.map((doc: string, docIndex: number) => (
                          <Box
                            key={docIndex}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setOpenPreview(true);
                                setImg(`${baseUrl}${doc}`);
                              }}
                            >
                              <PreviewIcon />
                            </span>
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                handleDownloadUrl(
                                  doc,
                                  `passport_doc_${docIndex}`,
                                );
                              }}
                            >
                              {downloadingFile ===
                              `passport_doc_${docIndex}` ? (
                                <CircularProgress
                                  sx={{
                                    width: "31px !important",
                                    height: "30px !important",
                                  }}
                                />
                              ) : (
                                <DocumentUploadIcon />
                              )}
                            </span>
                          </Box>
                        ))}
                      </Box>
                    );
                  })()
                ) : [
                    // "ss4_verified_form_files",
                    "business_incorporation",
                    "ein_document",
                    "w7_form",
                    "w7_signed_form",
                    "scan_passport",
                    "passport_scan",
                    "form_2848",
                    "form_2848_signed_form",
                    "ein_form_file",
                    "signed_ein_form",
                    // "verified_form_files",
                    "llc_document_file",
                    "llc_verified_documents",
                  ].includes(item.attribute ?? "") &&
                  typeof item.value === "string" ? (
                  <>
                    <span
                      style={{ cursor: "pointer", marginRight: "8px" }}
                      onClick={() => {
                        setOpenPreview(true);
                        setImg(
                          `${baseUrl}${
                            item.attribute === "verified_form_files" ||
                            item.attribute === "ss4_verified_form_files"
                              ? item.value[0]
                              : item.value
                          }`,
                        );
                      }}
                    >
                      <PreviewIcon />
                    </span>

                    <span
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        if (item.attribute && item.key) {
                          const value = item.value;

                          handleDownloadUrl(
                            item.attribute === "verified_form_files" ||
                              item.attribute === "ss4_verified_form_files"
                              ? item.value[0]
                              : item.value,
                            item.key,
                          );
                        }
                      }}
                    >
                      {downloadingFile === item?.key ? (
                        <>
                          <CircularProgress
                            sx={{
                              width: "31px !important",
                              height: "30px !important",
                            }}
                          />
                        </>
                      ) : (
                        <DocumentUploadIcon />
                      )}
                    </span>
                    {/* <span
                        style={{ cursor: "pointer" }}
                        onClick={(e) => {
                          e.preventDefault();
                          const fileUrl = `${baseUrl}${item.value ?? ""}`;
                          const fileName = item.title ?? "document";
                          const fileExtension = fileUrl
                            .split(".")
                            .pop()
                            ?.toLowerCase();
                          const finalFileName =
                            fileExtension && !fileName.endsWith(fileExtension)
                              ? `${fileName}.${fileExtension}`
                              : fileName;
                          handleDownload(fileUrl, finalFileName);
                        }}
                      >
                        {downloadingFile === item.value ? (
                          <CircularProgress sx={{ width: 31, height: 30 }} />
                        ) : (
                          <DocumentUploadIcon />
                        )}
                      </span> */}
                  </>
                ) : item?.attribute === "additional_members" ? (
                  item.value
                ) : !isNaN(Number(item.value)) &&
                  ![
                    "zip_code",
                    "number",
                    "related",
                    "order_number",
                    "id",
                  ].includes(
                    (item.attribute ?? item.title ?? "").toLowerCase(),
                  ) ? (
                  `$${Number(item.value)}`
                ) : (
                  item.value
                )}
              </FormTItleValue>
            </Box>
          );
        })}

        {hasItinDocument && data?.data?.verified_form_files[0] && (
          <Box
            sx={{
              borderBottom: "1px solid #EAF1FACC",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              paddingY: "20px",
            }}
          >
            <FormTItle>ITIN Document</FormTItle>
            <FormTItleValue
              sx={{ fontWeight: "500 !important", paddingLeft: "8px" }}
            >
              {selectedOrder?.productId === 3 &&
              Array.isArray(data?.data?.verified_form_files) &&
              data?.data?.verified_form_files.length > 1 ? (
                // Multiple ITIN Documents for tax filing (productId === 3)
                <Box sx={{ display: "flex", gap: "8px" }}>
                  {data?.data?.verified_form_files.map(
                    (doc: string, docIndex: number) => (
                      <React.Fragment key={docIndex}>
                        <span
                          style={{ cursor: "pointer", marginRight: "8px" }}
                          onClick={() => {
                            setOpenPreview(true);
                            setImg(`${baseUrl}${doc}`);
                          }}
                        >
                          <PreviewIcon />
                        </span>
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            handleDownloadUrl(
                              doc,
                              `itin_verified_doc_${docIndex}`,
                            )
                          }
                        >
                          {downloadingFile ===
                          `itin_verified_doc_${docIndex}` ? (
                            <CircularProgress
                              sx={{
                                width: "31px !important",
                                height: "30px !important",
                              }}
                            />
                          ) : (
                            <DocumentUploadIcon />
                          )}
                        </span>
                      </React.Fragment>
                    ),
                  )}
                </Box>
              ) : (
                // Single ITIN Document (existing behavior)
                <>
                  <span
                    style={{ cursor: "pointer", marginRight: "8px" }}
                    onClick={() => {
                      setOpenPreview(true);
                      setImg(`${baseUrl}${data?.data?.verified_form_files[0]}`);
                    }}
                  >
                    <PreviewIcon />
                  </span>

                  <span
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      handleDownloadUrl(
                        data?.data?.verified_form_files[0],
                        hasItinDocument,
                      )
                    }
                  >
                    {downloadingFile === data?.data?.verified_form_files[0] ? (
                      <>
                        <CircularProgress
                          sx={{
                            width: "31px !important",
                            height: "30px !important",
                          }}
                        />
                      </>
                    ) : (
                      <DocumentUploadIcon />
                    )}
                  </span>
                </>
              )}
            </FormTItleValue>
          </Box>
        )}

        {hasEINDocument && data?.data?.ss4_verified_documents[0] && (
          <Box
            sx={{
              borderBottom: "1px solid #EAF1FACC",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              paddingY: "20px",
            }}
          >
            <FormTItle>EIN Document</FormTItle>
            <FormTItleValue
              sx={{ fontWeight: "500 !important", paddingLeft: "8px" }}
            >
              {selectedOrder?.productId === 3 &&
              Array.isArray(data?.data?.ss4_verified_documents) &&
              data?.data?.ss4_verified_documents.length > 1 ? (
                // Multiple EIN Documents for tax filing (productId === 3)
                <Box sx={{ display: "flex", gap: "8px" }}>
                  {data?.data?.ss4_verified_documents.map(
                    (doc: string, docIndex: number) => (
                      <React.Fragment key={docIndex}>
                        <span
                          style={{ cursor: "pointer", marginRight: "8px" }}
                          onClick={() => {
                            setOpenPreview(true);
                            setImg(`${baseUrl}${doc}`);
                          }}
                        >
                          <PreviewIcon />
                        </span>
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            handleDownloadUrl(
                              doc,
                              `ein_verified_doc_${docIndex}`,
                            )
                          }
                        >
                          {downloadingFile ===
                          `ein_verified_doc_${docIndex}` ? (
                            <CircularProgress
                              sx={{
                                width: "31px !important",
                                height: "30px !important",
                              }}
                            />
                          ) : (
                            <DocumentUploadIcon />
                          )}
                        </span>
                      </React.Fragment>
                    ),
                  )}
                </Box>
              ) : (
                // Single EIN Document (existing behavior)
                <>
                  <span
                    style={{ cursor: "pointer", marginRight: "8px" }}
                    onClick={() => {
                      setOpenPreview(true);
                      setImg(
                        `${baseUrl}${data?.data?.ss4_verified_documents[0]}`,
                      );
                    }}
                  >
                    <PreviewIcon />
                  </span>

                  <span
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      handleDownloadUrl(
                        data?.data?.ss4_verified_documents[0],
                        hasEINDocument,
                      )
                    }
                  >
                    {downloadingFile ===
                    data?.data?.ss4_verified_documents[0] ? (
                      <>
                        <CircularProgress
                          sx={{
                            width: "31px !important",
                            height: "30px !important",
                          }}
                        />
                      </>
                    ) : (
                      <DocumentUploadIcon />
                    )}
                  </span>
                </>
              )}
            </FormTItleValue>
          </Box>
        )}

        {isViewButton && orderFormData.length > 4 && (
          <Grid size={{ xs: 12, md: 12 }} sx={{ textAlign: "end" }}>
            <Button
              onClick={() => setShowAll(!showAll)}
              variant="text"
              sx={{
                borderBottom: "1px solid #2977CC",
                borderRadius: 0,
                padding: 0,
                marginTop: 2,
                cursor: "pointer",
                backgroundColor: "transparent",
                "&:hover": {
                  backgroundColor: "transparent",
                },
              }}
            >
              {showAll ? "View less" : "View more"}
            </Button>
          </Grid>
        )}

        <PreviewModal open={openPreview} handleClose={handleClose} img={img} />
      </StyledGridBoxChild>
    </>
  );
};

export default OrderDetailCard;
